<template>
  <div class="container">
	  <app-header></app-header>
	  <div class="box"></div>
	  <div class="login-contanier">
	  	<div class="login-logo">
      		<img src="../img/login_logo.png">
      	</div>
	      <div id="login-container">
	        <div class="input-container user-container" :class="{sub: subHost}">
	          <i class="icon-user"></i>
	          <input type="text" 
	                 v-model="formLogin.account"
	                 v-focusme="'account'"
	                 @focus="inputFocus"
	                 @blur="inputBlur" 
	                 @keyup.enter.prevent="focus('password')"
	                 placeholder="请输入您的账号 admin@xxx" />
	          <span v-if="subHost">{{suffix}}</span>
					</div>
					<div class="input-container password-container">
	          <i class="icon-key"></i>
	          <input type="password"
	                 v-model="formLogin.password"
	                 v-focusme="'password'"
	                 @focus="inputFocus"
	                 @blur="inputBlur"
	                 @keyup.enter.prevent="login"
	                 placeholder="请输入您的密码"/>
	          <i class="eye-pw icon-eye"></i>
	        </div>	        
	        
	        <button class="btn-login" @click="login" :disabled="loading">{{btnText}}</button>	        
	      </div>
	    </div>
    <footer class="login-footer">
      <span>Copyright&nbsp;&copy;&nbsp;2006-2017&nbsp;<a href="http://www.lantel.net">浪腾软件</a>&nbsp;版权所有</span>
    </footer>
	  
  </div>
</template>

<script>
import Auth from '@/libs/auth'
import directive from '@/libs/directive.mixin'
import appHeader from './common/header.vue'
export default {
  name: 'login',
  mixins: [directive],
  components: {
  	appHeader
  },
  data () {
    return {
      loading:false,
      formLogin: {
        account: '',
        password: '',
        captcha: ''
      },
      subHost: window.CLIENT_DOMAIN
    }
  },
  computed: {
    suffix() {
      return this.subHost?`@${this.subHost}`:''
    },
    btnText(){
      if(this.loading){
        return '登录中...'
      }
      return '登录'
    }
  },
  methods: {
    focus(name) {
      this.inputelem = name
    },
    forgetPw() {
      this.$router.push('/forgetpw')
    },
    login() {
      if(/^\s*$/.test(this.formLogin.account)) {
        this.$Message.error('请输入您的账号')
        this.focus('account')
        return false
      }
      if(/^\s*$/.test(this.formLogin.password)) {
        this.$Message.error('请输入您的密码')
        this.focus('password')
        return false
      }
      this.doLogin(this.formLogin.account + this.suffix, this.formLogin.password, '')
    },
    doLogin(account,password,captcha){
      if(this.loading) return
        this.loading = true
        this.$http.post('signin',
          {account:account,
          password:password,
          captcha:captcha}
          )
        .then(response=>{
          Auth.setLocalLogin(response.body.data)
          let path = '/base'
          if(this.$route.query.referer){
            path = this.$route.query.referer
          }
          this.$router.push({ path: path })
        },response=>{
              this.loading = false
              let msg = response.body.message
              let msg_map = {
                'captcha_error':'验证码错误',
                'password_is_wrong':'密码错误',
                'account_does_not_exists':'账号不存在',
                'user_is_disabled':'账号被禁用',
                'client_time_not_correct':'您的电脑系统日期不对,请先将电脑日期设置正确!'
              }
              msg = msg_map[msg]?msg_map[msg]:msg;
              if(response.body.message == 'captcha_error'){
                  this.focus('captcha')
              }else if(response.body.message == 'password_is_wrong'){
                  this.focus('password') 
              }else if(response.body.message == 'account_does_not_exists'){
                  this.focus('account')
              }
              //this.refreshCaptcha()
              this.$Message.error(msg)
        })
    },
    inputFocus(event) {
      event.target.parentNode.style.borderColor = '#5cadff'
    },
    inputBlur(event) {
      event.target.parentNode.style.borderColor = '#999'
    }
  },
  mounted() {
    if(Auth.isLogin()) {
      this.$router.push({path:'/base'})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import '../style/mixin.less';
  .box {
    position: absolute;
    top: 70px;
    left: 0;
    margin: 0;    
    width: 100%;
    height: 450px;
    background: url(/static/img/vip/bg_login.png) no-repeat center center;
  }
  .login-contanier {
    position: absolute;
    top: 50%;
    margin-top: -180px;
    margin-left: -180px;
    left: 50%;
    width: 360px;
    height: 360px;
    padding: 60px;
    border-radius: 10px;
    background-color: #fff;
    .drop-shadow(0,0,8px,0.4);
    .login-logo {
      text-align: center;      
      img{
      	width: 80%;
      }
    }
  }
  .input-container {
    border-bottom: 1px solid #cccccc;    
    padding: 7px 10px;
    
    input {
      display: block;
      width: 90%;
      border: none;
      outline: none;
      &::placeholder {
      	color: #cccccc;
      }
    }
    i {
        color: #169bd5;
        margin-top: 5px;
        float: left;
    }
  }
  .user-container {
    margin-top: 25px;
    input {
      width: 90%;
    }
  }
  .user-container.sub {
    position: relative;
    margin-top: 25px;
    input {
      width: 40%;
    }
    span {
      position: absolute;
      top: 7px;
      right: 10px;
      color: #aaa;
    }
  }
  .password-container {
    position: relative;
    margin-top: 25px;    
    .eye-pw {
      position: absolute;
      font-size: 18px;
      right: 7px;
      top: 5px;
      cursor: pointer;
    }
  }
  .forget_pw {
    float: right;
    color: #169bd5;
    margin-top: 15px;
    cursor: pointer;
    &:hover {
        color: #2c7290;
        text-decoration: underline;
    }
  }
  .btn-login {
    width: 100%;
    color: #fff;
    border-radius: 5px;
    border: none;
    padding: 7px 0;
    margin-top: 2em;
    font-size: 16px;
    cursor: pointer;
        background: linear-gradient(to right, rgba(59, 179, 255,1), rgba(95, 226, 255,1));
    &:hover {
      background: linear-gradient(to right, rgba(59, 179, 255,.8), rgba(95, 226, 255,.8));
    }
    &:active {
      outline: none;
    }
  }
  .login-footer {
    position:absolute;
    left:0;
    width:100%;
    bottom:0;
    text-align: center;
    line-height: 50px;
    color: #263238;
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue